import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../Services/auth.service';
import { VolunteerSubsriptionService } from '../../Services/volunteerSubscription.service';
import Swal from 'sweetalert2'


@Component({
  selector: 'app-volunteer-subscription-form',
  template: require('./volunteer-subscription-form.component.html'),
  styles: [require('./volunteer-subscription-form.component.css')]
})
export class VolunteerSubscriptionFormComponent implements OnInit {
  
  EmailSame:boolean = false;
  emailCheckValue:string = ""
  destination:string = ""

  validActivity = false;

  volunteerInfo:any ={
    firstname: "",
    lastname: "",
    isMember: false,
    memberId: -1,
    email: "",
    telnr:"",
    remarks:""
  }
  
  activity:any={
    id:-1,
    allowRemarks: false
  }
  
  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private auth: AuthService,
    private volunteerSubsriptionService: VolunteerSubsriptionService

  ) { 
    
    route.params.subscribe(p => {
      if (p['id'])
        this.activity.id = +p['id'];
      else
        this.activity.id = 0;
      if (p['dest']){
        this.destination = p['dest']
      }

    });

    this.auth.observableAuth.subscribe(item => {
      if (! this.isEmptyObject(item)){
        this.volunteerInfo.firstname = item.firstName;
        this.volunteerInfo.lastname = item.lastName;
        this.volunteerInfo.isMember = true;
        this.volunteerInfo.memberId = item.id
      }
    });
  }

  ngOnInit() {
    this.getVolunteerActivitiesById();
  } 

  private getVolunteerActivitiesById(){
    this.volunteerSubsriptionService.getVolunteerActivityById(this.activity.id).subscribe( res =>{
      if (res.status == 200){   
        this.activity = res.value
        this.validActivity = true
      }else{
        this.validActivity = false
      }
    })
  }

  isEmptyObject(obj: any) {
    var name;
    for (name in obj) {
        if (obj.hasOwnProperty(name)) {
            return false;
        }
    }
    return true;
  }


  compareEmail(){
    if (this.volunteerInfo.email === this.emailCheckValue) {
      this.EmailSame = true
    }else{
      this.EmailSame = false
    }
  }

  GoHome(){
    var dest:string = "/";
    switch (this.destination) {
      case "":
        dest = "/";
        break;
      case "member":
        dest = "/subscription/volunteers/list/member";
        break;
      default:
        break;
    }
    this.router.navigate([dest]);
  }

  checkboxChanged(){
    this.volunteerInfo.firstname = this.auth.membersRusUser.firstName 
    this.volunteerInfo.lastname = this.auth.membersRusUser.lastName    
  }

  Subscribe(){
    var data = {
      "id": 0,
      "volunteerActivityID": this.activity.id,
      "firstName": this.volunteerInfo.firstname ,
      "lastName": this.volunteerInfo.lastname ,
      "isMember": this.volunteerInfo.isMember,
      "memberId": this.volunteerInfo.memberId,
      "email":  this.volunteerInfo.email,
      "telephoneNr": this.volunteerInfo.telnr,
      "remarks":this.volunteerInfo.remarks
    }
    this.volunteerSubsriptionService.addVolunteerSub(data).subscribe( (res:any)=>{
       if (res.status == 200){
        Swal.fire({
          title: 'Bedankt!',
          type: 'success',
          html:
            'Bedankt om je als vrijwilliger op te geven!' ,
          showCloseButton: false,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        }).then( (result)=>{
           this.GoHome()
        })
       }
    })
    

  }
 
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/volunteer-subscription-form/volunteer-subscription-form.component.ts